import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TrialDetail } from "../../../../../core/models/trial-detail.model";
import { Cultures } from "../../../../../core/constants/cultures";
import { AlertService } from "../../../../../shared/alert/alert.service";
import { TrialSupportLinkService } from "../../../../../core/services/trial-support-link.service";
import { TrialSupportLink } from "../../../../../core/models/trial-support-link.model";
import { TrialSupportLinkFormComponent } from "./trial-support-link-form/trial-support-link-form.component";
import { ConfirmActionModalComponent } from "../../../../../shared/confirm-action-modal/confirm-action-modal.component";

@Component({
  selector: 'app-trial-support-links',
  templateUrl: './trial-support-links.component.html',
  styleUrl: './trial-support-links.component.scss'
})
export class TrialSupportLinksComponent implements OnInit {
  @ViewChild('supportModal') supportModal: TrialSupportLinkFormComponent;
  @ViewChild('confirmModal') confirmModal: ConfirmActionModalComponent;

  @Input() trial: TrialDetail;

  @Output() hasChanged = new EventEmitter<boolean>(false);

  supportLinks: TrialSupportLink[] = [];

  availableCultures: { value: string, text: string }[] = [];
  supportInfoFilteredCultures: { value: string, text: string }[] = [];
  hasChanges: boolean = false;

  constructor(private _trialSupportLinkService: TrialSupportLinkService, private _alertService: AlertService) {
    Cultures.all().forEach(culture => {
      this.availableCultures.push({ value: culture.culture, text: culture.name });
    });
    this.supportInfoFilteredCultures = this.availableCultures;
  }

  ngOnInit() {
    this._trialSupportLinkService.list(this.trial.id).subscribe({
      next: links => {
        this.supportLinks = links;
      },
      error: err => {
        this._alertService.showErrorResponse(err);
      }
    });
  }

  splitCountries(countries: string): string[] {
    return countries.split(',');
  }

  onRemoveConfirmed(linkId: string) {
    this._trialSupportLinkService.remove(this.trial.id, linkId).subscribe({
      next: links => {
        this.supportLinks = links;
        this.hasChanges = true;
        this.hasChanged.emit(this.hasChanges);
        this._alertService.showSuccessAlert("Support link has been removed successfully.");
      },
      error: err => {
        this._alertService.showErrorResponse(err);
      }
    });
  }

  onRemove(link: TrialSupportLink) {
    this.confirmModal.showConfirmation(link.id);
  }
}
